export { currencyFormat }

function currencyFormat(fullNumber) {
	if (typeof fullNumber === 'number') {
		if (fullNumber <= 0) return '0'
		fullNumber = String(fullNumber).replaceAll('.', ',')
	}
	let splitNumber = fullNumber.replaceAll('.', '').split(',')
	let intPart = Array.from(splitNumber[0])
	let count = 0
	for (let i = intPart.length - 1; i > -1; i--) {
		count++
		if (count === 3) {
			if (i === 0) continue
			intPart.splice(i, 0, '.')
			count = 0
		}
	}
	splitNumber[0] = intPart.join('').trim()
	return splitNumber.join(',')
}
